import { render, staticRenderFns } from "./GangUp.vue?vue&type=template&id=07f8800a&scoped=true&"
import script from "./GangUp.vue?vue&type=script&lang=js&"
export * from "./GangUp.vue?vue&type=script&lang=js&"
import style0 from "./GangUp.vue?vue&type=style&index=0&id=07f8800a&lang=scss&scoped=true&"
import style1 from "./GangUp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8800a",
  null
  
)

export default component.exports